import powerBi from './power-bi/all';

export default function (controller, action, page) {
  if(controller === 'powerbi') powerBi(action, page);
}